import type { WeaponId } from '../core/types';
import type { Engine } from './engine';

/** 武器控制器统一接口（实现类各自持有运行时实体）。 */
export interface WeaponController {
  readonly id: WeaponId;
  owned: boolean;
  /** 构筑变化后同步等级 / 进化标记。 */
  syncBuild(level: number, evolved: boolean): void;
  update(engine: Engine, dt: number): void;
}

/** 冷却器：武器按攻速乘区触击。 */
export class Cooldown {
  private t = 0;

  /** 每步调用；返回 true 表示本步应触发，并用 interval 重置。 */
  tick(dt: number, interval: number): boolean {
    this.t -= dt;
    if (this.t > 0) return false;
    this.t = interval;
    return true;
  }

  reset(): void {
    this.t = 0;
  }
}
